import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProductCommunications } from 'tradera/state/ui/reducer';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';
import { PRODUCT_COMMUNICATION_DISMISSED } from 'tradera/constants/cookies';
import styles from './communication-banner.module.scss';
import { selectShippingRegionCountryCodeIso2 } from 'tradera/state/shipping-region/selectors';
import { areCountryCodesIso2Equal } from 'tradera/localization/countrycode';
import { useCookieUtil } from 'tradera/hooks/use-cookie-util';

export const CommunicationBanner = () => {
    const productCommunications = useSelector(
        (state) => state.ui.productCommunications
    );
    const dispatch = useDispatch();
    const country = useSelector(
        selectShippingRegionCountryCodeIso2
    ).toLowerCase();
    const cookieUtil = useCookieUtil();

    if (productCommunications.length === 0) {
        return null;
    }

    const selectedProductCommunication =
        productCommunications.find((x) =>
            x.countries?.some((c) => c?.toLowerCase() === country)
        ) ||
        productCommunications.find(
            (x) => !x.countries || x.countries.length === 0
        );

    if (!selectedProductCommunication) {
        return null;
    }

    const existingCookie = cookieUtil.readCookie(
        PRODUCT_COMMUNICATION_DISMISSED
    );

    if (
        existingCookie &&
        existingCookie.includes(selectedProductCommunication.entryId)
    ) {
        return null;
    }

    if (
        selectedProductCommunication.countries &&
        selectedProductCommunication.countries.length > 0 &&
        !selectedProductCommunication.countries.some((c) =>
            areCountryCodesIso2Equal(c, country)
        )
    ) {
        return null;
    }

    const closeBanner = (entryId) => {
        dispatch(updateProductCommunications([]));
        let cookie = cookieUtil.readCookie(PRODUCT_COMMUNICATION_DISMISSED);
        if (cookie && cookie.length > 0) {
            cookie = `${cookie};${entryId}`;
        } else {
            cookie = entryId;
        }
        const expireDate = new Date();
        expireDate.setMonth(expireDate.getMonth() + 1);
        cookieUtil.createCookie(
            PRODUCT_COMMUNICATION_DISMISSED,
            cookie,
            expireDate
        );
    };

    const { text, url, entryId } = selectedProductCommunication;
    return (
        <div
            data-testid="communication-banner"
            className={`${styles.communicationBanner} bg-dark w-100 p-1 d-flex justify-content-center align-items-center`}>
            <div
                className="d-flex flex-grow-1 justify-content-center align-items-center px-1"
                key={text}>
                {url ? (
                    <a href={url} rel="noreferrer">
                        <span className="text-white text-inter-medium size-dublin">
                            {text}
                        </span>
                    </a>
                ) : (
                    <span className="text-white text-inter-medium size-dublin">
                        {text}
                    </span>
                )}
            </div>

            <button
                className="btn btn-xs p-0"
                onClick={() => closeBanner(entryId)}>
                <CloseIcon className="icon icon-sm text-white" />
            </button>
        </div>
    );
};
